module.exports = __webpack_public_path__ + "img/collectiongallery_forestgreen.6bb2a7c.webp";